import { Application } from "@hotwired/stimulus"
import { registerControllers } from "stimulus-vite-helpers"

const application = Application.start()
registerControllers(application, import.meta.glob("./*_controller.js", { eager: true }))
